import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { RootState } from "../../../../redux/reducer";
import { selectMypageItemPerPage } from "../../../../redux/slice/commanPagination/commanPaginationSlice";
import { useTranslation } from "react-i18next";

const StyledPageSizeSelectorContainer = styled.div`
margin-right: 10px;
  border: none;
  select {
    padding: 0.3em 0.3em;
    margin: 0em;
    border: none;
    border-radius: 3px;
    font-size: 1em;
    border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
    background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
    color: ${(props) => props.theme.colors.base.black};
    width: 100px;

    ${(props) => props.theme.breakpoints.between("xs", "sm")} {
      padding: 0.2em 0.3em;
      margin: 0.2em;
    }
    background: url("/images/assets/doubledown.png") no-repeat;
    background-position: calc(100% - 0rem) center !important;
    appearance: none !important;
    background-size: 30px 20px;
  }
`;

export interface Iprops {
  setItemsPerPageHandler: (pageSize: number) => void;
}

const MypagePagination = (props: Iprops) => {
  const { setItemsPerPageHandler } = props;
  const pageCount = [50, 100];
  const items = ``;
  const pageSizeHandler = (e: any) => {
    const pageSize = parseInt(e.target.value);
    setItemsPerPageHandler(pageSize);
  };
  let [selection, setSelection] = useState(50);
  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectMypageItemPerPage(state)
  );

  useEffect(() => {
    if (selectItemPerPageValue !== null) {
      let savedCount: any = selectItemPerPageValue;
      setSelection(savedCount);
    } else {
      setSelection(selectItemPerPageValue);
    }
  }, [selectItemPerPageValue]);

  return (
    <StyledPageSizeSelectorContainer>
      <select onChange={pageSizeHandler}>
        {pageCount.map((count, index) => (
          <option
            key={index}
            selected={count === selection ? true : false}
            value={count}
          >{`${count} ${items}`}</option>
        ))}
      </select>
    </StyledPageSizeSelectorContainer>
  );
};

export default MypagePagination;
